export const quantumPageDE = {
  "seo": {
    "title": "Souveräne LLMs & Quanten-KI | pAIoneer Labs GmbH",
    "description": "Unser Ziel aus Deutschland heraus: unter Veridion („KI entwickelt KI weiter“) eigene kompakte Sprachmodelle und Quanten-Transformer entwickeln, die künftig mit großen Modellen aus den USA und China konkurrieren werden."
  },
  "hero": {
    "kicker": "Made in Germany · KI entwickelt KI",
    "title": "Souveräne LLMs & Quanten-KI",
    "claim": "Unser Ziel aus Deutschland heraus: eigene Sprachmodelle und Quanten-Transformer entwickeln, die künftig den großen Modellen aus den USA und China Konkurrenz machen werden.",
    "subtitle": "In realen Unternehmensprojekten wurden die bisherigen europäischen Ansätze — die deutschen Modelle von Aleph Alpha (wie Kolibri), die französischen Modelle rund um Mistral, EuroLLM und insbesondere das Schweizer Modell Apertus — gegen echte Praxisprobleme gebenchmarkt. Keines dieser Modelle genügt den Anforderungen im Unternehmen. Deshalb geht unsere KI unter [Veridion](veridion) („KI entwickelt KI weiter“) den nächsten Schritt: Sie erforscht und entwickelt den Weg zu kompakten Sprachmodellen Made in Germany, die weit leistungsfähiger sein werden als die französischen Modelle, und treibt als zweiten Schwerpunkt eigene Quanten-Transformer voran.",
    "cta": "Gespräch vereinbaren"
  },
  "pillars": {
    "title": "Woran unsere KI arbeitet",
    "subtitle": "Zwei Forschungsschwerpunkte, in denen unsere digitalen Mitarbeiter neue Architekturen entwerfen, im Simulator prüfen und Schritt für Schritt aufbauen.",
    "items": [
      {
        "title": "Was ein Sprachmodell im Alltag leisten muss",
        "description": "Im produktiven Einsatz zählen mehrstufiges logisches Schlussfolgern, verlässliche Werkzeugnutzung über lange Arbeitsketten, saubere Softwareentwicklung und fehlerfreie Büroprozesse. Daran messen wir jede Architektur von Beginn an."
      },
      {
        "title": "Kompakte Modelle für die eigene Infrastruktur",
        "description": "Statt immer größerer Rechenzentren lautet unser Ziel, hohe Denktiefe in einem kompakten Modell zu bündeln, das Unternehmen künftig vollständig lokal auf eigener Hardware betreiben können."
      },
      {
        "title": "Quanten-Transformer & Quanten-KI",
        "description": "Im zweiten Schwerpunkt erforschen wir, wie sich Transformer-Architekturen mit parametrisierten Quantenschaltkreisen und Tensor-Netzwerken verbinden lassen, um neue Modellklassen jenseits klassischer Netze zu erschließen."
      },
      {
        "title": "Eigene Quantum IDE & reale Quantenprozessoren",
        "description": "In unserer selbst entwickelten Quantum IDE entwerfen, simulieren und testen unsere KI-Mitarbeiter neue Quantenschaltkreise gegen klassische Vergleichsbasen, bevor sie auf echter Quantenhardware laufen."
      }
    ]
  },
  "gate": {
    "title": "Vom Forschungsstand zum Bauplan",
    "subtitle": "Jeder Entwicklungsschritt stützt sich auf geprüfte Literatur, unser Firmengedächtnis und messbare Vergleiche.",
    "stages": [
      {
        "step": "Schritt 01",
        "title": "Literaturauswertung & Firmengedächtnis",
        "description": "Unsere KI-Mitarbeiter werten fortlaufend neueste wissenschaftliche Arbeiten zu Sprachmodell- und Quantenarchitekturen aus und legen alle geprüften Befunde strukturiert im Wissensgraphen unseres Unternehmens ab."
      },
      {
        "step": "Schritt 02",
        "title": "Trainingsfahrplan & Schaltungssimulation",
        "description": "Gemeinsam mit der Produktentwicklung entsteht daraus der detaillierte Trainingsfahrplan für unser künftiges Sprachmodell, während parallel neue Quantenschaltkreise in der Quantum IDE erprobt werden."
      },
      {
        "step": "Schritt 03",
        "title": "Wissenschaftliche Prüfung im IDD-Prozess",
        "description": "Menschliche Physiker und KI-Forscher prüfen jede Hypothese, jede Messung und jeden Entwurf über [Intent-Driven Development](idd) (IDD) als Human-in-the-Loop und geben den nächsten Schritt frei."
      }
    ]
  },
  "stack": {
    "title": "Mensch und KI in einer Forschungseinheit",
    "subtitle": "Forschung, Produktentwicklung und wissenschaftliche Aufsicht greifen in festen Zyklen ineinander.",
    "items": [
      {
        "title": "Digitale Forscher im Dauerbetrieb",
        "description": "Spezialisierte KI-Mitarbeiter übernehmen Literaturrecherche, mathematische Herleitungen, Schaltungsentwurf und Auswertung rund um die Uhr."
      },
      {
        "title": "Physiker im Human-in-the-Loop",
        "description": "Menschliche Wissenschaftler geben die Forschungsrichtung vor, hinterfragen Annahmen und entscheiden über Freigaben, Hardware-Läufe und Veröffentlichungen."
      },
      {
        "title": "Verzahnung mit der Produktentwicklung",
        "description": "Abgestimmt mit unserer Produktentwicklung fließen belastbare Forschungsergebnisse direkt in unsere Werkzeuge und künftigen Unternehmenslösungen ein."
      },
      {
        "title": "Nachvollziehbar bis zur Quelle",
        "description": "Jede Architekturentscheidung, jede verworfene Variante und jedes Messergebnis bleibt dauerhaft dokumentiert und für Mensch wie KI jederzeit prüfbar."
      }
    ]
  },
  "cta": {
    "title": "Austausch zur Forschung",
    "subtitle": "Sie möchten sich zu unserer Forschung an souveränen Sprachmodellen und Quanten-Transformern austauschen? Schreiben Sie uns.",
    "button": "Nachricht schreiben"
  }
};
